export default {
  name: "index",
  props: {
    content: {
      type: String,
      default: function _default() {
        return '';
      }
    }
  }
};